import React from 'react';
import { useHistory, Switch, Route } from 'react-router';

// Hooks
import { useResponsiveScreenWidth } from 'Wpds/hooks/useResponsiveScreenWidth';

// Constants
import PageUrlsConstants from 'Shared/constants/PageUrls.constants';

// Components
import { WpPageLayout, WpPageHeader, WpPageTitle, WpPageBody } from 'Wpds/components/page-layout';
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import HomePageUtilityNavBar from './partials/HomePageUtilityNavBar';
import HomePageContent from './HomePageContent';
import UserProfileBody from 'Dashboard/components/UserProfilePage/UserProfileBody';
import TeamActionItems from 'Dashboard/components/TeamPage/TeamActionItems/TeamActionItems';
import SurfaceAI from 'Dashboard/components/SurfaceAIPage/SurfaceAI/SurfaceAI';
import SurfaceAIIntegrations from 'Dashboard/components/SurfaceAIPage/SurfaceAIIntegrations/SurfaceAIIntegrations';

// Styles
import './HomePage.scss';

const HomePage = () => {
  const history = useHistory();

  const { isLarge } = useResponsiveScreenWidth({
    isAtLeast: true,
    breakpoints: { lg: 1100 },
  });

  const handleBackClickToFeed = () => {
    history.push(PageUrlsConstants.SURFACEAI_PAGE);
  };

  const baseClassName = 'HomePageV3';

  return (
    <WpPageLayout width="full" className={baseClassName}>
      {isLarge ? (
        <div className={`${baseClassName}__header`}>
          <HomePageUtilityNavBar />
        </div>
      ) : (
        <Switch>
          <Route path={PageUrlsConstants.TEAM_PAGE}>
            <WpPageHeader width="full">
              <WpPageTitle title="Team Page" />
            </WpPageHeader>
          </Route>
          <Route path={[PageUrlsConstants.SURFACEAI_PAGE, PageUrlsConstants.SURFACEAI_INTEGRATIONS_PAGE]}>
            <WpPageHeader width="full">
              <WpPageTitle title="SurfaceAI" />
            </WpPageHeader>
          </Route>
        </Switch>
      )}
      <WpPageBody className={`${baseClassName}__body`}>
        <Switch>
          <Route path={PageUrlsConstants.CURRENT_USER_PROFILE_PAGE_HOME} component={UserProfileBody} />
          <Route path={PageUrlsConstants.TEAM_PAGE} component={TeamActionItems} />
          <Route path={PageUrlsConstants.SURFACEAI_PAGE} component={SurfaceAI} exact />
          <Route path={PageUrlsConstants.SURFACEAI_INTEGRATIONS_PAGE} exact>
            <SurfaceAIIntegrations
              button={
                <WpButton variant="tertiary" onClick={handleBackClickToFeed}>
                  <WpIcon name="angle-left" /> Back
                </WpButton>
              }
            />
          </Route>
          <Route
            path={[
              PageUrlsConstants.HOME_PAGE,
              PageUrlsConstants.HOME_PAGE_ITEM,
              PageUrlsConstants.HOME_PAGE_ITEM_COMMENTS,
            ]}
            component={HomePageContent}
          />
        </Switch>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default HomePage;
